import { useMemo, useState } from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import useGetDataPaginatedList from "../../../hooks/useGetDataPaginatedList";
import ClientLicenceService from "../../../services/ClientLicenceService";
import "./ListClientsLicence.css";
import Button from "../../../components/Button/Button";
import ModalComponent from "../../../components/Modal/ModalComponent";
import Input from "../../../components/Input/Input";
import { Copy } from "../../../components/Copy/Copy";
import { DropdownMenu } from "../../../components/DropdownMenu/DropdownMenu";
import { MdBlock } from "react-icons/md";
import { BsCpu, BsThreeDots } from "react-icons/bs";
import { BiTransfer } from "react-icons/bi";
import { UnitSelector } from "../../../components/UnitSelector/UnitSelector";

const ListClientsLicence = (props) => {
	const [clientLicence, setClientLicence] = useState([]);
	const [ownerId, setOwnerId] = useState();
	const [showModalUpdateOwner, setShowModalUpdateOwner] = useState(false);
	const [showModalUpdateSN, setShowModalUpdateSN] = useState(false);
	const [newSerial, setNewSerial] = useState("");
	const [licenseSelected, setLicenseSelected] = useState(null);

	const { data, columnClicked, maxPage, setColumnClicked, refetchData, isLoading } =
		useGetDataPaginatedList("licences", 1, props.filters, {
			collumnTitle: "createdAt",
			orderDirection: "DESC",
		});

	const transformedData = useMemo(() => {
		if (!data) return [];
		return data.map((item) => ({
			...item,
			SN_equipment: item.SN_equipment,
		}));
	}, [data]);

	const openUpdateModal = (licence) => {
		if (!licence) {
			alert("Selecione uma licença para atualizar o Serial Number.");
			return;
		}
		setNewSerial(licence.SN_equipment);
		setLicenseSelected(licence);
		setShowModalUpdateSN(true);
	};

	const openUpdateOwnerModal = (licence) => {
		if (!licence) {
			alert("Selecione uma licença para atualizar o proprietário.");
			return;
		}
		setOwnerId(licence.id_owner);
		setLicenseSelected(licence);
		setShowModalUpdateOwner(true);
	};

	const handleUpdateSN = async () => {
		const payload = { SN_equipment: newSerial };
		const response = await ClientLicenceService.updateSNEquipment(
			licenseSelected.id,
			payload,
		);
		if (response.status === 200) {
			const updatedLicences = clientLicence.map((item) =>
				item.id === licenseSelected.id
					? { ...item, SN_equipment: newSerial }
					: item,
			);
			setClientLicence(updatedLicences);
			setShowModalUpdateSN(false);
			setLicenseSelected(null);
		}
	};

	const handleUpdateOwner = async () => {
		const response = await ClientLicenceService.updateOwner(
			licenseSelected.id,
			ownerId,
		);
		if (response.data) {
			setShowModalUpdateOwner(false);
			setLicenseSelected(null);
		}
	};

	return (
		<>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					handleCollumnTitleClick={(collumnIndex) =>
						setColumnClicked(collumnIndex)
					}
					collumsObjIndex={[
						{
							collumnLabel: "Código de Vinculação",
							index: "bindingCode",
							type: "text",
						},
						{
							collumnLabel: "Serial Number",
							index: "SN_equipment",
							type: "text",
						},
						{
							collumnLabel: "Senha",
							index: "token_mqtt",
							type: "custom",
							custom: ({ row }) => {
								return (
									<Copy text={row.token_mqtt} showText={true} onClick={(e) => e.stopPropagation()} />
								);
							}
						},
						{
							collumnLabel: "Data de Início",
							index: "start_date",
							type: "date",
						},
						{ collumnLabel: "Data de Fim", index: "end_date", type: "date" },
						{
							collumnLabel: "Proprietário",
							index: "owner",
							type: "text",
						},
						{
							collumnLabel: "Alocado em",
							index: "name",
							type: "text",
						},
						{ collumnLabel: "Habilitada", index: "enabled", type: "boolean" },
						{
							collumnLabel: "Ações",
							index: 'actions',
							type: "custom",
							custom: ({ row }) => {
								return (
									<DropdownMenu
										onMouseEnter={e => e.stopPropagation()}
										onClick={e => e.stopPropagation()}
										content={!row.hasOwnerAccess ? (
											<div className="p-1! flex flex-row items-center gap-2">
												<MdBlock size={18} />
												Sem permissão em {row.owner}
											</div>
										) : null}
										options={row.hasOwnerAccess ? [
											{
												icon: BsCpu,
												label: "Atualizar Serial Number",
												onClick: () => {
													openUpdateModal(row);
												},
											},
											{
												icon: BiTransfer,
												label: "Transferir",
												onClick: () => {
													openUpdateOwnerModal(row);
												},
											},
										] : []}
									/>
								);
							}
						}
					]}
					data={transformedData}
				/>
			</div>
			<div className="card-visibility">
				{data &&
					data.map((clientLicence, index) => (
						<Card
							data={clientLicence}
							key={index}
							delete={() =>
								ClientLicenceService.deleteClientLicence(clientLicence.id)
							}
							navigateOnDelete={"../consulta-licencas"}
							navigateOnEdit={"/cadastro-licencas"}
						>
							<p className="card-content-title">{clientLicence.bindingCode}</p>
							<p className="card-content-title">
								{clientLicence.SN_equipment
									? clientLicence.SN_equipment
									: "Sem equipamento"}
							</p>
							<p className="card-content">
								Data início: {clientLicence.start_date}
							</p>
							<p className="card-content">Data fim: {clientLicence.end_date}</p>
							<p className="card-content">
								Habilitada: {clientLicence.enabled ? "Sim" : "Não"}
							</p>
						</Card>
					))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					refetchData("licences", page, props.filters, columnClicked)
				}
			/>
			{/* Modal para atualizar o Serial Number */}
			<ModalComponent
				modalIsOpen={showModalUpdateSN}
				handleConfirm={handleUpdateSN}
				handleCancel={() => setShowModalUpdateSN(false)}
				modalText={
					newSerial ? "Atualizar Serial Number" : "Adicionar Serial Number"
				}
			>
				<div className="modal-input-container">
					<Input
						type="text"
						labelText={"Serial Number do Equipamento"}
						value={newSerial}
						onChange={({ target }) => setNewSerial(target.value)}
						placeholder="Digite o Serial Number"
					/>
				</div>
			</ModalComponent>
			{/* Modal para transferir */}
			<ModalComponent
				modalIsOpen={showModalUpdateOwner}
				handleConfirm={handleUpdateOwner}
				handleCancel={() => setShowModalUpdateOwner(false)}
				modalText={
					"Transferir para outro proprietário"
				}
			>
				<div className="modal-input-container w-full!">
					<UnitSelector
						modalTitle={"Selecione o proprietário"}
						inputLabel={"Selecione o proprietário"}
						parentId={ownerId ? `${ownerId}` : null}
						setParentId={id => setOwnerId(Number(id))}
					/>
				</div>
			</ModalComponent>
		</>
	);
};

export default ListClientsLicence;
